// Floating WhatsApp CTA — fixed bottom-right on every public page.
// Tap → opens a direct chat with Walid on WhatsApp.
const WA_NUMBER = "971506465164"; // E.164, no '+', no spaces
const WA_PREFILL = encodeURIComponent(
    "Hi Walid — I'd like to chat about a project.",
);
const WA_URL = `https://wa.me/${WA_NUMBER}?text=${WA_PREFILL}`;

export default function WhatsAppButton() {
    return (
        <a
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with Walid on WhatsApp"
            title="Chat on WhatsApp"
            data-testid="whatsapp-cta"
            className="wa-fab"
            onClick={() => {
                if (typeof window !== "undefined" && window.dataLayer) {
                    window.dataLayer.push({
                        event: "whatsapp_click",
                        source: "floating_fab",
                    });
                }
            }}
        >
            <span className="wa-fab-pulse" aria-hidden="true" />
            <svg
                viewBox="0 0 32 32"
                width="28"
                height="28"
                fill="currentColor"
                aria-hidden="true"
            >
                <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977.962 2.78 1.06 1.74 2.292 3.226 4.196 4.282.732.41 1.512.738 2.292.952.327.086.97.227 1.477.227.473 0 1.118-.224 1.477-.566.293-.288.443-.728.443-1.182 0-.072-.014-.144-.04-.215-.115-.272-2.034-1.305-2.318-1.376zM16 27.286c-2.05 0-4.06-.587-5.79-1.69l-4.04 1.302 1.32-3.913a10.86 10.86 0 0 1-1.93-6.196c0-6.046 4.91-10.957 10.95-10.957s10.95 4.91 10.95 10.957S22.05 27.286 16 27.286zM16 4.5C9.094 4.5 3.5 10.094 3.5 17c0 2.272.62 4.51 1.793 6.475L3 30.5l7.18-2.297A12.93 12.93 0 0 0 16 29.5c6.906 0 12.5-5.594 12.5-12.5S22.906 4.5 16 4.5z" />
            </svg>
            <span className="sr-only">Chat on WhatsApp</span>
        </a>
    );
}
